import React from 'react'
import * as Bootstrap from 'react-bootstrap'
import { valoracionLegend } from '../constants/valoracionLegend';
import ReactStars from "react-rating-stars-component";

const InputValoracion = ({index, values, setFieldValue}) => {
    return (
        <Bootstrap.Form.Group
            as={Bootstrap.Col}
            style={{ marginBottom: 0 }}
            md="2"
        >
            <div style={{ marginTop: 22 }}>
                <div
                    style={{ display: "flex", flexFlow: "row" }}
                >
                    <ReactStars
                        count={5}
                        size={35}
                        name={`personaTalentos.${index}.valoracion`}
                        value={
                            values.personaTalentos[index].valoracion
                        }
                        onChange={(e) => {
                            setFieldValue(
                                `personaTalentos.${index}.valoracion`,
                                e
                            );
                        }}
                        activeColor="#00BBEC"
                    />
                    <div
                        style={{ marginTop: 15, marginLeft: 10 }}
                    >
                        {
                            valoracionLegend.find(
                                (x) =>
                                    x.key ==
                                    values.personaTalentos[index]
                                        .valoracion
                            ).value
                        }
                    </div>
                </div>
            </div>
        </Bootstrap.Form.Group>
    )
}

export default InputValoracion